import script from "./services-index.vue?vue&type=script&setup=true&lang=js"
export * from "./services-index.vue?vue&type=script&setup=true&lang=js"

import "./services-index.vue?vue&type=style&index=0&id=5abffa1d&lang=css"

const __exports__ = script;

export default __exports__